"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _flexboxgridModule = _interopRequireDefault(require("../../themes/flexboxgrid.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = function Container(_ref) {
  var fluid = _ref.fluid,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["fluid", "children", "className"]);

  var classes = (0, _classnames3["default"])(_defineProperty({}, _flexboxgridModule["default"]['container-fluid'], !!fluid), _defineProperty({}, _flexboxgridModule["default"].container, !fluid), className);
  return _react["default"].createElement("div", _extends({
    className: classes
  }, rest), children);
};

Container.propTypes = {
  children: _propTypes["default"].node.isRequired,
  fluid: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
// Container.defaultProps = {
//   fluid: false,
//   className: null
// };
var _default = Container;
exports["default"] = _default;